// AddScionsToTreatmentPopup.js

import { useState, useEffect, useRef, useContext } from "react";
import { useFetch } from "use-http";
import { Box, Text, Button, Layer, Header, Image } from "grommet";
import { FastForward} from "grommet-icons";
import { getDBURL, convertDateToDisplayformat, generateSyncId, correctTimeZone, usePopupFocus } from "../Utils/Utils";
import useTrapFocus from "../Utils/useTrapFocus";
import ConfirmPopupWindow from "./ConfirmPopupWindow";
import { UserContext } from "../../App";
import { without } from "underscore";

const AddScionsToTreatmentPopup = (props) => {
   // const { allStationTreatments, station, OpenTreatmentSheet} = props;
    const { station, OpenTreatmentSheet, selectedScionList, addScionToSelected} = props;
    console.log('AddScionsToTreatmentPopup props  >>  ', props);
    const currentUser = useContext(UserContext);
    // console.log("user:  ", currentUser);
    const [allStationTreatments, setAllStationTreatments] = useState([]);  // list of all treatments on station
    const [treatmentsList, setTreatmentsList]= useState([]);   // list of treatments 
    const [selectedTreatment, setSelectedTreatment] = useState('00000000-0000-0000-0000-000000000000');
    const [includesControlTreatment, setIncludesControlTreatment] = useState(false);  
    
    const { get, post } = useFetch(getDBURL());

    const [showConfirmPopup, setShowConfirmPopup] = useState(false); // show/hide 'Confirm' popup 
    const [warningMessage, setWarningMessage] = useState('');

    // Ref for the modal and focus trap to keep focus within it  
    const modalRef = useRef(null);
    useTrapFocus(modalRef, true); // Trap focus inside the modal while it's open

    usePopupFocus(showConfirmPopup, "confirm-msg");
    
    const selectedScions = getColumnValuesSeparatedByComma();

    function getColumnValuesSeparatedByComma() {
        return selectedScionList.map(item => item.Column).join(', ');
    }

    useEffect(() => {
        // console.log("useEffect:  fired on first mounting");
        loadScionsListInTreatment();
    }, []); 

    useEffect(() => {  
        // console.log('in useEffect !! ');  
        loadTreatmentList();              
        DrawTable();
    }, [allStationTreatments]); 

    // load treatments 
    async function loadScionsListInTreatment() {
        // console.log('In loadScionsListInTreatment station >> ', station);
        try {
            // setTreatmentsList([]);
            // added parameter date.now to prevent hash
            // const res = await get("/loadScionsListInTreatment/station_id=" + station.Id + "/dt=" + Date.now());
            const res = await get(`/loadScionsListInTreatment/station_id=${station.Id}/treatment_id=/dt=${Date.now()}`);
                // console.log('loadScionsListInTreatment >> ', res);
            if (res !== undefined && res.length > 0) {
                // console.log("treatments list: ", res[0]);
                setAllStationTreatments(res[0]); 
            }         
        }
        catch (error) {
            console.log('in loadTreatmentList error: ' + error.message);
        }
    };

    async function loadTreatmentList() {
        try {
            setTreatmentsList([]);
            // console.log('loaded allStationTreatments >> ', allStationTreatments);
            if (allStationTreatments !== undefined && allStationTreatments.length > 0) {
                let temp = [];
                let previous = null;
                allStationTreatments.map((treatment) => {

                    temp.push ({
                    //    treatmentID: treatment.TreatmentId === null ? 0 : treatment.TreatmentId,
                        treatmentID: treatment.TreatmentId,
                        treatmentName: treatment.TreatmentName === '' ? "New treatment" : treatment.TreatmentName,
                        treatmentStatus: treatment.TreatmentStatus,
                        treatmentColor:
                            treatment.TreatmentStatus === 5 
                                ? "#00C781" //"status-ok"
                                : treatment.TreatmentStatus === 4 
                                    ? "#FFAA15"  // "accent-4"
                                    : treatment.TreatmentStatus === 3 
                                    ? "#61aec9" 
                                    : "#666666", // "status-unknown",
                        treatmentStartDate: treatment.TreatmentCreateDate,
                        treatmentFinishDate: treatment.TreatmentFinishDate,
                        scions: treatment.ScionColumns,
                        scionsStartDate: treatment.ScionStartDate,
                        scionsEndDate: treatment.ScionEndDate,
                    })                      
                    previous = treatment;
                    if (treatment.TreatmentId === '00000000-0000-0000-0000-000000000000')
                        setIncludesControlTreatment(true);
                });
                // console.log('in useEffect temp >> ', temp);
                setTreatmentsList(temp);
            }
        }
        catch (error) {
            console.log('in loadTreatmentList error: ' + error.message);
        }
    }

    // hides the "Confirm" popup window
    const onClose = () => {
        setWarningMessage('');
        setShowConfirmPopup(false);
    };
  
    // opens a popup window when the "edit" button is clicked
    const openConfirmWindow = (treatmentData) => {
        // console.log(' << in function openConfirmWindow >> ', treatmentData); 
        const msg = treatmentData === null ? `Do you want to add selected scions: ${selectedScions} to 'Control treatment' group`: `Do you want to add selected scions: ${selectedScions} to treatment ${treatmentData.treatmentName}`
        const teatmentNum = treatmentData === null ? '00000000-0000-0000-0000-000000000000' : treatmentData.treatmentID; 
        setWarningMessage(msg);
        setSelectedTreatment(teatmentNum);
        setShowConfirmPopup(true);
    }

    // fires when the "Confirm" button is clicked in the "Confirm" popup
    const onConfirm = async () => {
        // console.log(' << in function onConfirm >> '); 
        await addNewTreatmentScion();
        await props.loadAllTreatmentsByStation();
        await props.loadTreatmentList(station);
        await props.loadScions(station.Id)
     };

    /*  Runs when adding an additional scion to an existing treatment
        Inserts one row per scion into the VEM_Treatment_Scion table **/
    async function addNewTreatmentScion() {
        try {
            let values = []; 
            selectedScionList.map((item) => 
            { 
                const ts =  
                {  
                    Id: generateSyncId(),
                    TreatmentID: selectedTreatment === null ? '00000000-0000-0000-0000-000000000000' : selectedTreatment,
                    ScionID: item.Id,
                    CreateDate:  correctTimeZone(new Date()),
                    CreatedBy: currentUser.email,
                    FinishedAt: null,
                    FinishedBy: null,
                    LastSyncDate: correctTimeZone(new Date()), 
                }
                values = values.concat(ts); 
            });

            const res = await post("/insertTreatmentScions", values);

            if (res > 0) {
                selectedScionList.forEach(scion => addScionToSelected(scion, false));
            }
            props.setAddTreatmentsPopupOpen(false)
            props.setShowTreatments(true);
        }
        catch (error) {
            console.error('Error in f-n addNewTreatmentScion ', error.message);
        }
    };

    const DrawTable = () =>
    {
        
        // console.log('In Draw table treatmentsList >> ', treatmentsList);
        if (treatmentsList.length === 0)
            return;

        const rows = [];
        let lastTreatmentPrinted = null;

        treatmentsList.map((item) => {
            rows.push(DrawRow(item, lastTreatmentPrinted));
            lastTreatmentPrinted = item;
        });
        return rows;
    } 


    const DrawRow = (treatment, prev) =>
    {
        // console.log('treatment >> ', treatment);       
        const next = (prev === null) || ((prev !== null) && (treatment.treatmentID !== prev.treatmentID));

        return(
            <Box  key={Math.random(Date.now())}  align="center"  margin="xxsmall" >

                <>
                    { next &&
                    <Box width="100%"  direction="row-responsive"  align="center" 
                        pad={{ vertical: "small" }}
                        style={prev !== null ? {paddingTop: "50px"} : {paddingTop: "10px"}}
                    > 


                        <Box width={{ width: '180px', min: '150px' }} direction="row" > 
                            <Box pad="xxsmall" width= "180px" height="30px" >
                                <Button 
                                    color="#33333310"
                                    style={{color: treatment.treatmentColor, padding: 0, fontSize: "18px"}}
                                    primary                            
                                    label={treatment.treatmentName}
                                    onClick={
                                        (treatment.treatmentID !== null) 
                                        ? () => openConfirmWindow(treatment)
                                        : () => OpenTreatmentSheet(treatment)
                                        }
                                />
                            </Box> 
                        </Box>
                   
                        <Box  width="200px"  direction="row">                            
                            {treatment.treatmentStartDate !== null ? <Text >&nbsp;start:&ensp;</Text> : ""}
                            <Text weight="bold" style={{fontStyle: "italic"}} >{convertDateToDisplayformat(treatment.treatmentStartDate)}</Text>                    
                        </Box> 
                        <Box  width="200px"  direction="row" >
                            {treatment.treatmentFinishDate !== null ? <Text >&nbsp;finish:&ensp;</Text> : ""}
                            <Text weight="bold" style={{fontStyle: "italic"}} >{convertDateToDisplayformat(treatment.treatmentFinishDate)}</Text>                    
                        </Box>
                    </Box> 
                    }
                    {(treatment.treatmentID !== null) &&
                    <Box width="100%"  direction="row-responsive" > 
                        <Box   width={{ width: '680px', min: '680px' }} direction="row-responsive">
                            <Box pad="xxsmall" width= "20px"></Box> 
                            <Box width= "30px" pad={{vertical: "xsmall"}} >
                                <FastForward  color="brand" size='15px' />                                
                            </Box>   
                            <Box  width="300px"  direction="row" >
                                <Text >&nbsp;vines:&ensp;</Text>
                                <Text weight="bold" style={{fontStyle: "italic"}} >{treatment.scions}</Text>                    
                            </Box> 
                            <Box  width="300px"  direction="row">                            
                                {treatment.scionsStartDate !== null ? <Text >&nbsp;start:&ensp;</Text> : ""}
                                <Text weight="bold" style={{fontStyle: "italic"}} >{treatment.scionsStartDate}</Text>   
                            </Box> 
                            <Box  width="300px"  direction="row">                            
                                {treatment.scionsEndDate !== null ? <Text >&nbsp;finish:&ensp;</Text> : ""}
                                <Text weight="bold" style={{fontStyle: "italic"}} >{treatment.scionsEndDate}</Text>  
                            </Box>                   

                        </Box> 

                    </Box>
                    }
                </>

            </Box>
        );
    } 

    const style = {
        border: "2px solid",       
        margin: "10px",
    };


    return (
        <Layer
            id="add-sc-to-treat"
            ref={modalRef}
            tabIndex="-1"
            position="center"
            background="light-3"
            onEsc={() =>  props.setAddTreatmentsPopupOpen(false)}
            onClickOutside={() =>  props.setAddTreatmentsPopupOpen(false)}
        >
            <Box pad="small" margin="small" gap="small" width="large" border>

                <Box style={{position:"relative"}}>
                    <Header margin="none" background="light-4" pad="small" height="xxsmall" justify="around">
                        <Text alignSelf="start" color="brand" size="large"  align="center" >
                            <strong>Select treatment</strong>
                        </Text>
                    </Header>
                    <Box height="xsmall" width="xsmall" 
                        style={{position:"absolute", right: "3%", top: "15px"}}
                        right="0px"
                        >
                            <Image
                                size="contain"
                                src="Grape.png"                                  
                            />
                    </Box>                 
                </Box>

                <Box alignSelf="center"  width="75%">                                    
                    <Text  margin="medium" textAlign="center"  size="large" ><span style={{whiteSpace: 'pre-line'}}><strong>Choose a treatment for selected scions</strong></span></Text>
                </Box>

                <Box alignSelf="center"  width="90%">
                    {DrawTable()}
                </Box>  

            {!includesControlTreatment &&
                <Box alignSelf="center"  width="90%"  pad={{ top: 'large'}}>
                    <Box  width= "180px" height="30px" > 
                        <Button 
                            color="#33333310"
                            style={{color: '#00739D', padding: 0, fontSize: "18px"}}
                            primary                            
                            label={'Control treatment'}
                            onClick={ () => openConfirmWindow(null) }
                        />
                    </Box> 
                </Box> 
            }


                <Box
                    as="footer"
                    gap="small"
                    direction="row"
                    align="center"
                    justify="end"
                    pad={{ top: 'medium', bottom: 'small' }}
                >
                    <Button
                    //    disabled={disable}
                        label={
                            <Text color="white">
                                <strong>Close</strong>
                            </Text>
                        }
                        onClick={() => props.setAddTreatmentsPopupOpen(false)}
                        primary                  
                    />  
                </Box>
            </Box>


            {showConfirmPopup && (
            <ConfirmPopupWindow
                msg={warningMessage}
                onClose={onClose}
                onConfirm={onConfirm}
            />
            )} 
        </Layer>
    )
}

export default AddScionsToTreatmentPopup;
